// Generated by scripts/generate-catalogue.mjs. Do not edit.
import type { FrameSpec } from '../frames';
export const FRAME_LOADERS: Record<string,()=>Promise<FrameSpec>> = {
"java-jungle-onyx-night-1": () => import('./models/java-jungle-onyx-night-1').then(m=>m.default),
"java-jungle-sunset-glow-1": () => import('./models/java-jungle-sunset-glow-1').then(m=>m.default),
"java-jungle-caramel-swirl-1": () => import('./models/java-jungle-caramel-swirl-1').then(m=>m.default),
"flores-breeze-golden-hour-1": () => import('./models/flores-breeze-golden-hour-1').then(m=>m.default),
"flores-breeze-morning-lagoon-1": () => import('./models/flores-breeze-morning-lagoon-1').then(m=>m.default),
"flores-breeze-silver-mist": () => import('./models/flores-breeze-silver-mist').then(m=>m.default),
"flores-breeze-sunlight-aura": () => import('./models/flores-breeze-sunlight-aura').then(m=>m.default),
"flores-breeze-olive-gove-1": () => import('./models/flores-breeze-olive-gove-1').then(m=>m.default),
"bali-blue-morning-lagoon-1": () => import('./models/bali-blue-morning-lagoon-1').then(m=>m.default),
"bali-blue-dark-forest-1": () => import('./models/bali-blue-dark-forest-1').then(m=>m.default),
"bali-blue-olive-gove-json": () => import('./models/bali-blue-olive-gove-json').then(m=>m.default),
"borneo-bliss-olive-gove-1": () => import('./models/borneo-bliss-olive-gove-1').then(m=>m.default),
"borneo-bliss-dark-forest-1": () => import('./models/borneo-bliss-dark-forest-1').then(m=>m.default),
"borneo-bliss-charcoal-cloud-1": () => import('./models/borneo-bliss-charcoal-cloud-1').then(m=>m.default),
"gili-escape-amber-sun-1": () => import('./models/gili-escape-amber-sun-1').then(m=>m.default),
"gili-escape-olive-gove": () => import('./models/gili-escape-olive-gove').then(m=>m.default),
"bali-blue-midnight-sky": () => import('./models/bali-blue-midnight-sky').then(m=>m.default),
"bali-blue-mystic-mauve-1": () => import('./models/bali-blue-mystic-mauve-1').then(m=>m.default),
"borneo-bliss-black-sun": () => import('./models/borneo-bliss-black-sun').then(m=>m.default),
"borneo-bliss-velvet-noir-1": () => import('./models/borneo-bliss-velvet-noir-1').then(m=>m.default),
"gili-escape-caramel-swirl-1": () => import('./models/gili-escape-caramel-swirl-1').then(m=>m.default),
"bali-blue-caramel-swirl": () => import('./models/bali-blue-caramel-swirl').then(m=>m.default),
"bali-blue-pink-lemonade": () => import('./models/bali-blue-pink-lemonade').then(m=>m.default),
"gili-escape-silver-mist": () => import('./models/gili-escape-silver-mist').then(m=>m.default),
"java-joy-caramel-swirl": () => import('./models/java-joy-caramel-swirl').then(m=>m.default),
"java-joy-olive-gove": () => import('./models/java-joy-olive-gove').then(m=>m.default),
"java-joy-velvet-noir-copy": () => import('./models/java-joy-velvet-noir-copy').then(m=>m.default),
"java-joy-morning-lagoon-1": () => import('./models/java-joy-morning-lagoon-1').then(m=>m.default),
"komodo-rise-olive": () => import('./models/komodo-rise-olive').then(m=>m.default),
"cove": () => import('./models/cove').then(m=>m.default),
"cove-black": () => import('./models/cove-black').then(m=>m.default),
"cove-tortoise": () => import('./models/cove-tortoise').then(m=>m.default),
"lombok-luxe-tuxedo-tranquility-1": () => import('./models/lombok-luxe-tuxedo-tranquility-1').then(m=>m.default),
"lombok-luxe-midnight-sky-1": () => import('./models/lombok-luxe-midnight-sky-1').then(m=>m.default),
"lombok-luxe-black-sun-1": () => import('./models/lombok-luxe-black-sun-1').then(m=>m.default),
"raja-reef-olive-gove": () => import('./models/raja-reef-olive-gove').then(m=>m.default),
"raja-reef-sunlight-aura": () => import('./models/raja-reef-sunlight-aura').then(m=>m.default),
"raja-reef-morning-lagoon": () => import('./models/raja-reef-morning-lagoon').then(m=>m.default),
"sumba-hills-black-sun": () => import('./models/sumba-hills-black-sun').then(m=>m.default),
"sumba-hills-olive-gove": () => import('./models/sumba-hills-olive-gove').then(m=>m.default),
"sumba-hills-sunlight-aura": () => import('./models/sumba-hills-sunlight-aura').then(m=>m.default),
"komodo-rise-velvet-noir": () => import('./models/komodo-rise-velvet-noir').then(m=>m.default),
"komodo-rise-caramel-swirl": () => import('./models/komodo-rise-caramel-swirl').then(m=>m.default),
"vieux-carre": () => import('./models/vieux-carre').then(m=>m.default),
"silfira": () => import('./models/silfira').then(m=>m.default),
"airmax": () => import('./models/airmax').then(m=>m.default),
"amber-tide": () => import('./models/amber-tide').then(m=>m.default),
"coca-colada": () => import('./models/coca-colada').then(m=>m.default),
"tequila-sunrise-2": () => import('./models/tequila-sunrise-2').then(m=>m.default),
"muse-2": () => import('./models/muse-2').then(m=>m.default),
"muse": () => import('./models/muse').then(m=>m.default),
"muse-1": () => import('./models/muse-1').then(m=>m.default),
"nostalgia": () => import('./models/nostalgia').then(m=>m.default),
"solace": () => import('./models/solace').then(m=>m.default),
"sgroppino": () => import('./models/sgroppino').then(m=>m.default),
"stone": () => import('./models/stone').then(m=>m.default),
"nebula": () => import('./models/nebula').then(m=>m.default),
"eye-candy": () => import('./models/eye-candy').then(m=>m.default),
"midnight-mimosa-2": () => import('./models/midnight-mimosa-2').then(m=>m.default),
"citrus-twist-2": () => import('./models/citrus-twist-2').then(m=>m.default),
"stereo": () => import('./models/stereo').then(m=>m.default),
"slate-sour": () => import('./models/slate-sour').then(m=>m.default),
"saoirse": () => import('./models/saoirse').then(m=>m.default),
"dawn": () => import('./models/dawn').then(m=>m.default),
"the-abyss-2": () => import('./models/the-abyss-2').then(m=>m.default),
"citrus-twist-1": () => import('./models/citrus-twist-1').then(m=>m.default),
"solivina": () => import('./models/solivina').then(m=>m.default),
"luxe-silver-mist": () => import('./models/luxe-silver-mist').then(m=>m.default),
"luxe-caramel-swirl": () => import('./models/luxe-caramel-swirl').then(m=>m.default),
"luxe-velvet-noir": () => import('./models/luxe-velvet-noir').then(m=>m.default),
"soulstice": () => import('./models/soulstice').then(m=>m.default),
"glint": () => import('./models/glint').then(m=>m.default),
"lilt": () => import('./models/lilt').then(m=>m.default),
"cove-1": () => import('./models/cove-1').then(m=>m.default),
"citrus-twist": () => import('./models/citrus-twist').then(m=>m.default),
"bulltini": () => import('./models/bulltini').then(m=>m.default),
"frosted": () => import('./models/frosted').then(m=>m.default),
"pisco-sour-1": () => import('./models/pisco-sour-1').then(m=>m.default),
"bourbon-buzz-1": () => import('./models/bourbon-buzz-1').then(m=>m.default),
"the-abyss-1": () => import('./models/the-abyss-1').then(m=>m.default),
"the-abyss": () => import('./models/the-abyss').then(m=>m.default),
"tequila-temptation-1": () => import('./models/tequila-temptation-1').then(m=>m.default),
"manhattan-magic-1": () => import('./models/manhattan-magic-1').then(m=>m.default),
"margarita-mojo-copy": () => import('./models/margarita-mojo-copy').then(m=>m.default),
"cherry-blossom-breeze-1": () => import('./models/cherry-blossom-breeze-1').then(m=>m.default),
"milky-punch-3": () => import('./models/milky-punch-3').then(m=>m.default),
"milky-punch-2": () => import('./models/milky-punch-2').then(m=>m.default),
"milky-punch-copy": () => import('./models/milky-punch-copy').then(m=>m.default),
"milky-punch-1": () => import('./models/milky-punch-1').then(m=>m.default),
"vino-vision-1": () => import('./models/vino-vision-1').then(m=>m.default),
"daiquiri-dream-1": () => import('./models/daiquiri-dream-1').then(m=>m.default),
"daiquiri-dream-copy": () => import('./models/daiquiri-dream-copy').then(m=>m.default),
"moonbeam-s-elexir-3": () => import('./models/moonbeam-s-elexir-3').then(m=>m.default),
"mysterious-martini-1": () => import('./models/mysterious-martini-1').then(m=>m.default),
"mudslide-1": () => import('./models/mudslide-1').then(m=>m.default),
"bourbon-bold-2": () => import('./models/bourbon-bold-2').then(m=>m.default),
"bourbon-bold-1": () => import('./models/bourbon-bold-1').then(m=>m.default),
"tequila-sunrise-1": () => import('./models/tequila-sunrise-1').then(m=>m.default),
"tequila-sunrise": () => import('./models/tequila-sunrise').then(m=>m.default),
"bellini-babe-3": () => import('./models/bellini-babe-3').then(m=>m.default),
"bellini-babe-2": () => import('./models/bellini-babe-2').then(m=>m.default),
"bellini-babe-1": () => import('./models/bellini-babe-1').then(m=>m.default),
"moonbeam-s-elexir-2": () => import('./models/moonbeam-s-elexir-2').then(m=>m.default),
"moonbeam-s-elexir-1": () => import('./models/moonbeam-s-elexir-1').then(m=>m.default),
"paloma-perfection-2": () => import('./models/paloma-perfection-2').then(m=>m.default),
"paloma-perfection-1": () => import('./models/paloma-perfection-1').then(m=>m.default),
"monaco-moment-1": () => import('./models/monaco-moment-1').then(m=>m.default),
"monaco-moment": () => import('./models/monaco-moment').then(m=>m.default),
"moon-river-2": () => import('./models/moon-river-2').then(m=>m.default),
"moon-river-1": () => import('./models/moon-river-1').then(m=>m.default),
"moon-river": () => import('./models/moon-river').then(m=>m.default),
"dreamer-s-delight": () => import('./models/dreamer-s-delight').then(m=>m.default),
"moonbeam-s-elexir": () => import('./models/moonbeam-s-elexir').then(m=>m.default),
"whispering-willow": () => import('./models/whispering-willow').then(m=>m.default),
"elderflower-enemy": () => import('./models/elderflower-enemy').then(m=>m.default),
"sparkling-sip-copy": () => import('./models/sparkling-sip-copy').then(m=>m.default),
"sparkling-sip": () => import('./models/sparkling-sip').then(m=>m.default),
"bellini-brilliance": () => import('./models/bellini-brilliance').then(m=>m.default),
"bellini-bombshell": () => import('./models/bellini-bombshell').then(m=>m.default),
"bellini-babe": () => import('./models/bellini-babe').then(m=>m.default),
"angel-s-kiss": () => import('./models/angel-s-kiss').then(m=>m.default),
"cherry-blossom-breeze": () => import('./models/cherry-blossom-breeze').then(m=>m.default),
"midnight-mirage": () => import('./models/midnight-mirage').then(m=>m.default),
"bushwacker": () => import('./models/bushwacker').then(m=>m.default),
"pisco-sour": () => import('./models/pisco-sour').then(m=>m.default),
"paloma-perfection": () => import('./models/paloma-perfection').then(m=>m.default),
"bramble-lover": () => import('./models/bramble-lover').then(m=>m.default),
"french-seventy-five": () => import('./models/french-seventy-five').then(m=>m.default),
"gibson-groove": () => import('./models/gibson-groove').then(m=>m.default),
"mahogany-mirage": () => import('./models/mahogany-mirage').then(m=>m.default),
"vino-vision": () => import('./models/vino-vision').then(m=>m.default),
"manhattan-magic": () => import('./models/manhattan-magic').then(m=>m.default),
"clover-club": () => import('./models/clover-club').then(m=>m.default),
"rum-razzle": () => import('./models/rum-razzle').then(m=>m.default),
"jungle-bird": () => import('./models/jungle-bird').then(m=>m.default),
"sake-shades": () => import('./models/sake-shades').then(m=>m.default),
"bourbon-buzz": () => import('./models/bourbon-buzz').then(m=>m.default),
"bourbon-sidecar": () => import('./models/bourbon-sidecar').then(m=>m.default),
"mudslide": () => import('./models/mudslide').then(m=>m.default),
"tequila-temptation-copy": () => import('./models/tequila-temptation-copy').then(m=>m.default),
"tequila-temptation": () => import('./models/tequila-temptation').then(m=>m.default),
"daiquiri-dream": () => import('./models/daiquiri-dream').then(m=>m.default),
"margarita-muse": () => import('./models/margarita-muse').then(m=>m.default),
"margarita-mojo": () => import('./models/margarita-mojo').then(m=>m.default),
"ocean-s-embrace-copy": () => import('./models/ocean-s-embrace-copy').then(m=>m.default),
"milky-punch": () => import('./models/milky-punch').then(m=>m.default),
"rob-roy": () => import('./models/rob-roy').then(m=>m.default),
"gilmet-joy-copy": () => import('./models/gilmet-joy-copy').then(m=>m.default),
"gilmet-joy": () => import('./models/gilmet-joy').then(m=>m.default),
"singapore-sling": () => import('./models/singapore-sling').then(m=>m.default),
"secret-serendipity": () => import('./models/secret-serendipity').then(m=>m.default),
"mirthful-mimosa": () => import('./models/mirthful-mimosa').then(m=>m.default),
"mimosa-marvel": () => import('./models/mimosa-marvel').then(m=>m.default),
"magnetic-martini-copy": () => import('./models/magnetic-martini-copy').then(m=>m.default),
"mysterious-martini-copy": () => import('./models/mysterious-martini-copy').then(m=>m.default),
"mysterious-martini": () => import('./models/mysterious-martini').then(m=>m.default),
"handmade-1": () => import('./models/handmade-1').then(m=>m.default),
"midnight-mimosa-1": () => import('./models/midnight-mimosa-1').then(m=>m.default),
"midnight-mimosa": () => import('./models/midnight-mimosa').then(m=>m.default),
"airmax-4": () => import('./models/airmax-4').then(m=>m.default),
"airmax-3": () => import('./models/airmax-3').then(m=>m.default),
"airmax-2": () => import('./models/airmax-2').then(m=>m.default),
"airmax-1": () => import('./models/airmax-1').then(m=>m.default),
"cosmopolitan-cruise": () => import('./models/cosmopolitan-cruise').then(m=>m.default),
"monaco-moment-copy": () => import('./models/monaco-moment-copy').then(m=>m.default),
"rose-radiance": () => import('./models/rose-radiance').then(m=>m.default),
"velvet-hamme": () => import('./models/velvet-hamme').then(m=>m.default),
"velvet-hamme-1": () => import('./models/velvet-hamme-1').then(m=>m.default),
"shindig-3": () => import('./models/shindig-3').then(m=>m.default),
"shindig-2": () => import('./models/shindig-2').then(m=>m.default),
"shindig-copy": () => import('./models/shindig-copy').then(m=>m.default),
"shindig-1": () => import('./models/shindig-1').then(m=>m.default),
"shindig": () => import('./models/shindig').then(m=>m.default),
};
